<div class="container">
  <div class="row" style="height: 5px; background-color: #431a2a; margin-bottom: 15px; margin-top: 10px;"></div>
  <div class="row">
    <div class="col">
      <img src="../../../assets/images/physioLife logo artwork-02.png" alt="smartlab"
        class="img-fluid float-start" width="50px" height="50px">
      <h2 style="color: #431a2a;"> PHYSIOLIFE CLINIC </h2>
    </div>
    <div class="col text-end">
      <p style="font-size: medium; color: #431a2a; margin-bottom: 4px;">INVOICE NUMBER</p>
      <strong style="color: #431a2a;">{{ invoiceNumber }}</strong>
    </div>
  </div>
  <div class="row">
    <br>
    </div>
    <div class="row">
      <div class="col">
        <div class="side_border">
          <p style="font-size: medium; color: #431a2a;">PATIENT INFORMATION</p>
          {{invoice?.payment_details?.patient?.patient_name}} <br>
          {{invoice?.payment_details?.patient?.patient_number}} <br>
          {{invoice?.payment_details?.patient?.patient_phone}} <br>
          {{invoice?.payment_details?.patient?.patient_address}}. <br>
        </div>
      </div>
      <div class="col">
        <div class="side_border">
          <p style="font-size: medium; color: #431a2a;">Clinician INFORMATION</p>
          {{invoice?.payment_details?.doctor?.doctor_name}} <br>
          {{invoice?.details?.doctor?.visiting_reason}} <br>
          {{invoice?.date | date}} <br>
        </div>
      </div>
    </div>

    <hr style="margin-top: 15px; height:2px;border:none;color:#431a2a;background-color:#431a2a;">

    <div class="row" style="border: 1px solid #e1e3e7; border-radius: 5px;">
      <table class="table" style="border-bottom: 1px dashed #51689c;">
        <thead>
          <tr>
            <th scope="col">DESCRIPTION</th>
            <th scope="col" class="text-end">Period</th>
            <th scope="col" class="text-end">Amount</th>
            <th scope="col" class="text-end">QTY</th>
            <th scope="col" class="text-end">AMOUNT</th>
          </tr>
        </thead>
        <tbody>
          @for (item of invoice?.payment_details?.payment_services ?? []; track item) {
            <tr>
              <td>
                <h6>{{item?.service_name}}</h6>
                <pre>{{item?.service_date}}</pre>
              </td>
              <td class="text-end">@if (item?.service_period) {
                <span>{{item?.service_period }} minutes</span>
              }</td>
              <td class="text-end">{{item.service_price | number:'1.3-3'}} <small>OMR</small></td>
              <td class="text-end">{{item.quantity}}</td>
              <td class="text-end">{{item.final_price | number:'1.3-3'}} <small>OMR</small></td>
            </tr>
          }
        </tbody>
        @if (package) {
          <tfoot>
            <tr>
              <td colspan="5">
                <p>
                  <small>{{package?.no_sessions_took }} of {{
                  package?.no_sessions }} used sessions</small><br>
                  <small>{{+package?.paied_amount }} of {{
                    +package?.full_price }} <small>OMR</small> paid amount</small>
                  </p>
                </td>
              </tr>
            </tfoot>
          }
        </table>

        <div class="col" style="padding-right: 5px;">
          <table class="table">
            <tr>
              <td><b>TOTAL</b></td>
              <td class="text-end" colspan="3">{{invoice?.service_price | number:'1.3-3'}} <small>OMR</small></td>
            </tr>
            <tr>
              <td><b>DISCOUNT</b></td>
              @if (invoice && !invoice.details?.offer) {
                <td class="text-end">{{(+invoice.service_price - +invoice.final_price)}}<small>OMR</small></td>
              }
            </tr>
            <tr>
              <td><b>TOTAL PAYMENT AMOUNT</b></td>
              <td class="text-end" colspan="3">{{invoice?.final_price | number:'1.3-3'}} <small>OMR</small></td>
            </tr>
            <tr>
              <td colspan="4"><br></td>
            </tr>
            <tr>
              <td><b>PAYMENT</b></td>
              <td colspan="3" class="text-end">
                <h5 style="padding: 0px;">{{invoice?.payment_type }}</h5>
              </td>
            </tr>
            <tr>
              <td colspan="4" style="font-weight: bolder;">
                ** This is system generated invoice and no signature required.
              </td>
            </tr>
            <tr>
              <td colspan="4" style="font-size: small;">
                {{ invoiceNumber }}
              </td>
            </tr>
          </table>
          <img src="../../../assets/images/stamp.png" alt="physioLife" class="float-end" height="150px" width="150px"
            style="margin-top:-30px; margin-bottom:-150px">
        </div>
      </div>

      <div style="margin-top: 70px;">
        <button type="button" class="btn btn-outline-dark" id="myPrntbtn" onclick="window.print();">Print/Share</button>
      </div>
    </div>